angular.module('main').directive('snTextAngular', [
	'$timeout',
	'$rootScope',
	'$window',
	'messageService',
	function($timeout, $rootScope, $window, messageService) {
		return {
			restrict: 'AE',
			scope: {
				drModel: '=snModel',
				snFilesModel: '=', // attachments  snFilesModel
				toolbar: '@snTools',
				fieldName: '@snName',
				fileDropHandler: '&snFileDropHandler',
				forbidImgPaste: '=snForbidImgPaste'
			},
			replace: true,
			transclude: true,
			link(scope) {
				scope.cutEl = true;

				scope.linkVariables = [
					'%contract_link%',
					'%invoice_link%',
					'%quote_link%',
					'%questionnaire_link%',
					'%galleries_link%'
				];

				if (!scope.drModel) {
					scope.drModel = '';
				}

				function placeCaretAtEnd(el) {
					if (
						typeof $window.getSelection !== 'undefined' &&
						typeof document.createRange !== 'undefined'
					) {
						const range = document.createRange();
						range.selectNodeContents(el);
						range.collapse(false);
						const sel = $window.getSelection();
						sel.removeAllRanges();
						sel.addRange(range);
					} else if (typeof document.body.createTextRange !== 'undefined') {
						const textRange = document.body.createTextRange();
						textRange.moveToElementText(el);
						textRange.collapse(false);
						textRange.select();
					}
				}

				function wrapTextInParagraph(inputedText, textContainer) {
					textContainer.html(`<p>${inputedText}</p>`);
					placeCaretAtEnd(textContainer[0].childNodes[0]);
				}

				function deleteSingleBr(inputedText, textContainer, brTag) {
					inputedText = inputedText.replace(brTag, '');
					textContainer.html(inputedText);
				}

				function trimVariablesDomain(href) {
					let link = href;

					scope.linkVariables.forEach(linkVar => {
						const startIndex = link.indexOf(linkVar);
						if (startIndex !== -1) {
							link = link.slice(startIndex, startIndex + linkVar.length);
						}
					});

					return link;
				}

				scope.$on('checkedFiles', (e, data) => {
					scope.$broadcast('attachments', data);
				});

				scope.$watch('drModel', (newValue, oldValue) => {
					if (newValue !== oldValue) {
						const textContainer = $('.focussed [id^=taTextElement]');

						if (
							(scope.fieldName === 'chosen_package' ||
								scope.fieldName === 'updateproduct_description') &&
							textContainer &&
							textContainer[0] &&
							textContainer[0].innerText.length > 4000
						) {
							textContainer.text(textContainer[0].innerText.slice(0, 4000));
						}

						if (textContainer.length) {
							const TEXT_CODE = 3;
							const inputedText = textContainer.html();
							const firstChildNode = textContainer[0].childNodes[0];
							const brTag = /<br[^>]*>/;
							const hasText = textContainer.text().length !== 0;
							const hasNodeBr = brTag.test(firstChildNode.innerHTML);

							if (inputedText === '<br>') {
								textContainer.html('<p></p>');
							}

							if (firstChildNode.nodeType === TEXT_CODE) {
								wrapTextInParagraph(inputedText, textContainer);
							}

							if (!hasText && hasNodeBr) {
								deleteSingleBr(inputedText, textContainer, brTag);
							}
						}

						let elLength;

						try {
							elLength = angular.element(newValue).length;
						} catch (e) {
							elLength = angular.element(`<div>${newValue}</div>`).text()
								.length;
						}

						if (!newValue || elLength === 0) {
							if (textContainer.text().length === 0) {
								scope.drModel = '<p></p>';
							}
						}
					}
				});

				$rootScope.$watch('crashedTextAngular', (newValue, oldValue) => {
					if (newValue && newValue !== oldValue) {
						rebuild();
					}
				});

				function rebuild() {
					$timeout(() => {
						console.error('Text Angular was crached');
					}, 0);
				}

				scope.isAttachment = false;

				scope.link2edit = {
					linkTo: '',
					url: '',
					select: ''
				};

				if (scope.snFilesModel) {
					scope.isAttachment = Array.isArray(scope.snFilesModel.attachments);
				}

				if (scope.fieldName) {
					let fields = document.querySelectorAll(
						`div > [name="${scope.fieldName}"]`
					);

					if (fields.length > 1) {
						fields = document.querySelectorAll(
							`div > [name^="${scope.fieldName}"]`
						);
						scope.fieldName += `_${fields.length}`;
					}
				}

				scope.fieldEndName = scope.fieldName;

				function replaceTag(html, array, newTag) {
					let expr1, expr2, targetTag;

					array.forEach(element => {
						targetTag = element.toLowerCase();
						expr1 = new RegExp(`<${targetTag}`, 'g');
						expr2 = new RegExp(`</${targetTag}>`, 'g');

						html = html.replace(expr1, `<${newTag}`);
						html = html.replace(expr2, `</${newTag}>`);
					});

					return html;
				}

				function removeStyling(emailText) {
					try {
						if (!emailText) {
							return emailText;
						}

						const startCut = '<!--StartFragment-->';
						const htmlInsertOffset = emailText.indexOf(startCut);

						if (htmlInsertOffset !== -1) {
							const startOffset = startCut.length;
							const endCut = '<!--EndFragment-->';

							let textTmp = emailText.slice(
								emailText.indexOf(startCut) + startOffset
							);
							textTmp = textTmp.slice(0, textTmp.indexOf(endCut));

							emailText = textTmp;
						}

						let thisTag, tagName, tmpId, newhtml, tmpContainer, allTags, result;

						const forbidBoxTags = ['HTML', 'BODY', 'PRE', 'DL', 'DT', 'DD'];
						const forbidBoldTags = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];

						tmpId = `tagCleaner_${Math.random()
							.toString(36)
							.substr(2, 9)}`;

						newhtml = replaceTag(emailText, forbidBoxTags, 'div');
						newhtml = replaceTag(newhtml, forbidBoldTags, 'b');
						newhtml = newhtml.replace(/style="[^"]*"/g, '');
						newhtml = newhtml.replace(/class="[^"]*"/g, '');

						$(document.body).append(
							`<div id="${tmpId}" class="hide">${newhtml}</div>`
						);

						tmpContainer = $(`#${tmpId}`);
						allTags = tmpContainer.find('*');

						let i = 0;
						const max = allTags.length;

						for (; i < max; i++) {
							thisTag = allTags.eq(i);

							tagName = thisTag.prop('tagName');

							if (forbidBoxTags.indexOf(tagName) !== -1) {
								$(thisTag).replaceWith($(`<div>${thisTag[0].innerHTML}</div>`));
							} else if (forbidBoldTags.indexOf(tagName) !== -1) {
								$(thisTag).replaceWith($(`<b>${thisTag[0].innerHTML}</b>`));
							} else if (tagName === 'A') {
								thisTag[0].href = trimVariablesDomain(thisTag[0].href);

								const linkBody = thisTag[0].href
									? thisTag[0].outerHTML
									: thisTag[0].innerHTML;

								$(thisTag).replaceWith($(`<span>${linkBody}</span>`));
							} else if (tagName === 'CODE') {
								$(thisTag).replaceWith(
									$(`<span>${thisTag[0].innerHTML}</span>`)
								);
							}
						}

						result = tmpContainer.html();
						tmpContainer.remove();
						return result;
					} catch (e) {
						console.warn('wrong past', e);
					}
				}

				scope.pasteHandlerTA = function(html) {
					try {
						const editor = $('.textarea-quad > .focussed')
							.find('input')
							.first();
						editor.focus();
						editor.blur();
					} catch (e) {
						console.warn('wrong past', e);
					}
					const forbidImage = scope.forbidImgPaste && /^<img[^>]*>$/.test(html);
					if (forbidImage) messageService.showToaster('e_0', 'email');
					let text = forbidImage ? '' : removeStyling(html);
					text = `<span>${text}</span>`;
					return text;
				};

				scope.showModalEditLink = function(e) {
					scope.$evalAsync();
					scope.link2edit.select = '';
					delete scope.link2edit.linkTo;
					delete scope.link2edit.url;

					scope.$evalAsync();
					const tmpId = `link-edited-id-${Math.random()
						.toString(36)
						.substr(2, 9)}`;
					const target = $(e.target);
					target.parents('.sn-ta-editor').addClass(tmpId);
					scope.link2edit = { select: `.${tmpId} .linkEdited` };
				};

				scope.$on('ta-drop-event', () => {
					if (scope.forbidImgPaste) messageService.showToaster('e_1', 'email');
				});
			},
			template() {
				const html = `
                 <div class="sn-ta-editor">
                        <div class="textarea-quad">

                        <text-angular ng-model="drModel" name="{{fieldEndName}}" ta-file-drop="fileDropHandler" ta-focussed-class="focussed" ta-html-editor-class="form-content" ta-text-editor-class="form-content" ta-paste="pasteHandlerTA($html)" ng-disabled="button_disable" ta-toolbar="{{toolbar}}">
                        </text-angular>
                        <span class="editLinkTips" ng-click="showModalEditLink($event)" style="display:none;">
                        <i class="fi fi-edit"></i>Edit link
                    </span>
                    </div>

                    <modal-link-editor sn-link-data="link2edit"></modal-link-editor>
                    <sn-attach-files ng-if="isAttachment" sn-attachments="snFilesModel"></sn-attach-files>
                    <attach-files-modal></attach-files-modal>
                  </div>
             `;

				return html;
			}
		};
	}
]);



// WEBPACK FOOTER //
// ./web/js/components/snTextAngular.js